/**
 * Language initialization plugin
 * Ensures language is loaded from localStorage on app startup
 */
export default defineNuxtPlugin(() => {
  const { initializeLanguage } = useLanguage()
  
  // Initialize language from localStorage
  initializeLanguage()
})
